export function getDeepLinkedAssetId(pathname?: string | null): string | null {
  try {
    const resolvedPathname = typeof pathname === 'string'
      ? pathname
      : (typeof window !== 'undefined' ? window.location.pathname : '');

    const match = resolvedPathname.match(/^\/asset\/([^/]+)\/?$/);
    const rawAssetId = match?.[1];
    if (!rawAssetId) return null;

    const assetId = decodeURIComponent(rawAssetId).trim();
    return assetId || null;
  } catch {
    return null;
  }
}
